<template>
  <span>
    <span v-if="resolutionStatus == 'RN'" class="green--text">
      {{ $t("modal.caseReport.label.resolvedNoMatches") }}
    </span>

    <span v-if="resolutionStatus == 'RP'" class="green--text">
      {{ $t("modal.caseReport.label.resolvedProceed") }}
    </span>

    <span v-if="resolutionStatus == 'RE'" class="green--text">
      {{ $t("modal.caseReport.label.resolvedClearedEnhanced") }}
    </span>

    <span v-if="resolutionStatus == 'RD'" class="red--text">
      {{ $t("modal.caseReport.label.resolvedDiscontinue") }}
    </span>

    <span v-if="resolutionStatus == 'U' ">
      {{ $t("modal.caseReport.label.unresolved") }}
    </span>

    <span v-if="resolutionStatus == 'F'" class="red--text">
      {{ $t("modal.caseReport.label.flagged") }}
    </span>

  </span>
</template>

<script>
export default {
  name: "ResolutionStatusChips",
  components: {},
  props: {
      resolutionStatus:{}
  },
  methods: {
  }
};
</script>
